import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import {isEmpty} from "../../util/Validation";
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import OnboardLink from "../../component/base/onboard-link-component/OnboardLink";
import SeatOrTicketNumberComponent from "../../component/custom/SeatOrTicketNumberComponent";
import LoginStateManager from "../../util/LoginStateManager";
import Const from "../../constant/Const";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import {useSetRecoilState} from 'recoil';
import {informationAtom} from '../../store/InformationStore';

const ForgotPasscodePage = (props) => {
    const setInformation = useSetRecoilState(informationAtom);
    const {t, i18n, navigate, location, user} = props.props;

    const [error, setError] = useState(null);

    const {processForgotPassword} = new LoginStateManager(props.props, VerifyTypeEnum.FORGOT_PASSCODE);

    const validation = () => {
        let recordSeatNumber = seatNumber;
        if (!visibleSeatNumber) {
            recordSeatNumber = JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.user?.seatNumber || "";
            setSeatNumber(recordSeatNumber);
        }
        if (NotNullCheck(control())) {
            processForgotPassword(memberId.replace(" | ", ""), recordSeatNumber, ticketNumber);
        }
    }

    const control = () => {
        let recordSeatNumber = seatNumber;
        let valid = {
            memberId: (memberId == null || memberId.length === 0) ? t('error.empty_member_id') : null,
            seatNumber: (seatNumber == null || seatNumber.length === 0) ? t('error.empty_seat_number') : null,
            ticketNumber: (ticketNumber == null || ticketNumber.length === 0) ? t('error.empty_ticket_number') : null,
            approve: (approve == null || !approve) ? t('error.empty_approve') : null,
        };
        if (!visibleSeatNumber) {
            selectEnterOption.value = "1";
            valid.seatNumber = null;
            recordSeatNumber = JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.user?.seatNumber || "";
            setSeatNumber(recordSeatNumber);
        } else {
            if (seatNumber != null && seatNumber.length > 0) {
                valid.seatNumber = /^[\da-z]+$/i.test(seatNumber) ? null : t('error.valid_seat_number');
            }
        }
        setError(valid);
        if (selectEnterOption.value === "1") valid.ticketNumber = null;
        else valid.seatNumber = null;
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    useEffect(() => {
        if (user.seatNumber !== null || user.ticketNumber !== null) {
            setVisibleSeatNumber(false);
        }
        setInformation(prev => ({
            ...prev,
            type: "forget_password"
        }));
    }, [])
    const [visibleSeatNumber, setVisibleSeatNumber] = useState(true);

    const [memberId, setMemberId] = useState(user.memberId);
    const [seatNumber, setSeatNumber] = useState(null);
    const [ticketNumber, setTicketNumber] = useState(null);

    const [approve, setApprove] = useState(null);
    const [selectEnterOption, setSelectEnterOption] = useState({value: '1', label: t('login.seat_number_option')});
    const [milesProcessing, setMilesProcessing] = useState(false);

    useEffect(() => {
        if (selectEnterOption.value === '1') setVisibleOptions(true);
        else setVisibleOptions(false);
    }, [selectEnterOption]);
    const [visibleOptions, setVisibleOptions] = useState(true);

    const handleSelectOption = (e) => {
        setSelectEnterOption(e);
        setError(null);
        setSeatNumber(null);
        setTicketNumber(null);
    }

    const isNavigateRoutePayment = () => {
        return location.state === "payment";
    }

    const isNavigateRouteOffer = () => {
        return location.state === "offer";
    }

    return (
        <div>
            <HeaderComponent showBack title={t('login.forgot_password')} content={t('login.forgot_password_content')}/>

            <div className="content-root">

                <OnboardInput placeholder={t('login.input_ms_member_id')} onChange={(e) => setMemberId(e)}
                              error={error?.memberId}
                              mask={{mask: "TK \\| 9{1,9}", definitions: {"*": {casing: "upper"}}}}
                              validation={isEmpty(memberId, t('error.empty_member_id'))}
                              value={memberId}/>

                <div className="h-8"/>

                {visibleSeatNumber && (
                    <SeatOrTicketNumberComponent changeSeatNumber={(e) => setSeatNumber(e)}
                                                 changeTicketNumber={(e) => setTicketNumber(e)}
                                                 errorSeatNumber={error?.seatNumber}
                                                 errorTicketNumber={error?.ticketNumber}
                                                 valueSeatNumber={seatNumber}
                                                 valueTicketNumber={ticketNumber}
                                                 changeOption={(e) => handleSelectOption(e)}
                    />
                )}

                <div className="h-20"/>

                <EndUseAgreementTTNETCheckbox
                    showMilesApprove
                    milesApproveOnChange={(val) => setMilesProcessing(val)}
                    value={approve}
                    error={error?.approve}
                    onChange={(e) => setApprove(e)}/>

                <div className="h-20"/>

                <OnboardButton label={isNavigateRoutePayment() ? t('continue') : t('login.login_btn')}
                               onClick={() => validation()}/>

                <div className="h-46"/>

                {!isNavigateRoutePayment() && !isNavigateRouteOffer() && (
                    <OnboardLink label={t('login.miles_and_smiles_with_login')}
                                 onClick={() => navigate("/login")}/>
                )}

            </div>

            <FooterComponent/>

        </div>
    );
};

export default ForgotPasscodePage;

